import { combineReducers } from 'redux';
import alert from './alert';
import auth from './auth';
import profile from './profile';
import trip from './trip';
import agentProfile from './agentProfile.reducer';
import chat from './chat.reducer';

export default combineReducers({
  alert,
  auth,
  profile,
  trip,
  agentProfile,
  chat
});
